import {
    createFieldInput,
    createFieldInputNumber
} from "../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../i18n";
import { createColumnInput, createColumnInputNumber } from "../../../../components/table/c-table.logic";


export const createColumns = () => {
    const columns = [
        createColumnInputNumber({ title: () => i18n.global.t("views.productType.seq"), dataIndex: "seq", search: { visible: () => false } }),
        createColumnInput({ title: () => i18n.global.t("views.productType.key"), dataIndex: "key", align: 'center' }),
        createColumnInput({ title: () => i18n.global.t("views.productType.value"), dataIndex: "value" }),
        createColumnInput({ title: () => i18n.global.t("views.productType.valueEn"), dataIndex: "valueEn" }),
        createColumnInput({ title: () => i18n.global.t("views.productType.expired"), dataIndex: "attribute.samplingValidPeriod", search: { visible: () => false } }),
    ]
    return columns
}

export const createField = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldInputNumber({
            key: 'seq',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.productType.seq'),
            inputProp: () => ({ value: modelRef.seq, 'onUpdate:value': value => modelRef.seq = value, disabled: viewOnly })
        }),
        createFieldInput({
            key: 'key',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.productType.key'),
            inputProp: () => ({ value: modelRef.key, 'onUpdate:value': value => modelRef.key = value, disabled: viewOnly })
        }),
        createFieldInput({
            key: 'value',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.productType.value'),
            inputProp: () => ({ value: modelRef.value, 'onUpdate:value': value => modelRef.value = value, disabled: viewOnly })
        }),
        createFieldInput({
            key: 'valueEn',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.productType.valueEn'),
            inputProp: () => ({ value: modelRef.valueEn, 'onUpdate:value': value => modelRef.valueEn = value, disabled: viewOnly })
        }),
        createFieldInput({
            key: 'attribute.samplingValidPeriod',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.productType.expired'),
            inputProp: () => ({ value: modelRef.attribute['samplingValidPeriod'], 'onUpdate:value': value => modelRef.attribute['samplingValidPeriod'] = value, disabled: viewOnly, sorter: false })
        }),
    ]
}
